var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsvIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_181_2578",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.1471 60H4.85294C2.17274 60 0 58.0812 0 55.7143V4.28572C0 1.91878 2.17274 0 4.85294 0H37.5L60 19.8701V55.7143C60 58.0812 57.8273 60 55.1471 60Z",
    fill: "url(#paint0_linear_181_2578)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_181_2578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.1471 60H4.85294C2.17274 60 0 58.0812 0 55.7143V4.28572C0 1.91878 2.17274 0 4.85294 0H37.5L60 19.8701V55.7143C60 58.0812 57.8273 60 55.1471 60Z",
    fill: "url(#paint1_linear_181_2578)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_181_2578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 19.8701H57.3701C46.3962 19.8701 37.5 10.974 37.5 0L60 19.8701Z",
    fill: "url(#paint2_linear_181_2578)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.8849 35.3622H20.2287C20.1529 34.9266 20.0133 34.5407 19.8097 34.2045C19.6061 33.8636 19.3527 33.5748 19.0497 33.3381C18.7467 33.1013 18.401 32.9238 18.0128 32.8054C17.6293 32.6823 17.215 32.6207 16.7699 32.6207C15.9792 32.6207 15.2784 32.8196 14.6676 33.2173C14.0568 33.6103 13.5786 34.188 13.233 34.9503C12.8873 35.7079 12.7145 36.6335 12.7145 37.7273C12.7145 38.84 12.8873 39.7775 13.233 40.5398C13.5833 41.2973 14.0616 41.8703 14.6676 42.2585C15.2784 42.642 15.9768 42.8338 16.7628 42.8338C17.1984 42.8338 17.6056 42.777 17.9844 42.6634C18.3679 42.545 18.7112 42.3722 19.0142 42.1449C19.322 41.9176 19.58 41.6383 19.7884 41.3068C20.0014 40.9754 20.1482 40.5966 20.2287 40.1705L22.8849 40.1847C22.7855 40.8759 22.5701 41.5246 22.2386 42.1307C21.9119 42.7367 21.4834 43.2718 20.9531 43.7358C20.4228 44.1951 19.8026 44.5549 19.0923 44.8153C18.3821 45.071 17.5938 45.1989 16.7273 45.1989C15.4489 45.1989 14.3078 44.9029 13.304 44.3111C12.3002 43.7192 11.5095 42.8646 10.9318 41.7472C10.3542 40.6297 10.0653 39.2898 10.0653 37.7273C10.0653 36.16 10.3565 34.8201 10.9389 33.7074C11.5213 32.59 12.3144 31.7353 13.3182 31.1435C14.322 30.5516 15.4583 30.2557 16.7273 30.2557C17.5369 30.2557 18.2898 30.3693 18.9858 30.5966C19.6818 30.8239 20.3021 31.1577 20.8466 31.598C21.3911 32.0336 21.8385 32.5687 22.1889 33.2031C22.544 33.8329 22.776 34.5526 22.8849 35.3622ZM33.2028 34.4531C33.1365 33.8329 32.8571 33.3499 32.3647 33.0043C31.877 32.6586 31.2425 32.4858 30.4613 32.4858C29.9121 32.4858 29.4409 32.5687 29.0479 32.7344C28.6549 32.9001 28.3543 33.125 28.146 33.4091C27.9376 33.6932 27.8311 34.0175 27.8263 34.3821C27.8263 34.6851 27.895 34.9479 28.0323 35.1705C28.1744 35.393 28.3661 35.5824 28.6076 35.7386C28.8491 35.8902 29.1166 36.018 29.4102 36.1222C29.7037 36.2263 29.9996 36.3139 30.2979 36.3849L31.6616 36.7259C32.2108 36.8537 32.7388 37.0265 33.2454 37.2443C33.7567 37.4621 34.2137 37.7367 34.6161 38.0682C35.0233 38.3996 35.3453 38.7997 35.582 39.2685C35.8188 39.7372 35.9371 40.2865 35.9371 40.9162C35.9371 41.7685 35.7193 42.5189 35.2837 43.1676C34.8481 43.8116 34.2184 44.3158 33.3945 44.6804C32.5754 45.0402 31.5835 45.2202 30.4187 45.2202C29.2871 45.2202 28.3046 45.045 27.4712 44.6946C26.6426 44.3442 25.994 43.8329 25.5252 43.1605C25.0612 42.4882 24.8103 41.669 24.7724 40.7031H27.3647C27.4026 41.2098 27.5588 41.6312 27.8335 41.9673C28.1081 42.3035 28.4656 42.5545 28.9059 42.7202C29.351 42.8859 29.8481 42.9688 30.3974 42.9688C30.9703 42.9688 31.4722 42.8835 31.9031 42.7131C32.3387 42.5379 32.6796 42.2964 32.9258 41.9886C33.172 41.6761 33.2975 41.3116 33.3022 40.8949C33.2975 40.5161 33.1862 40.2036 32.9684 39.9574C32.7506 39.7064 32.4452 39.4981 32.0522 39.3324C31.6639 39.1619 31.2094 39.0104 30.6886 38.8778L29.0337 38.4517C27.8358 38.1439 26.8888 37.6776 26.1928 37.0526C25.5015 36.4228 25.1559 35.5871 25.1559 34.5455C25.1559 33.6884 25.3879 32.938 25.8519 32.294C26.3207 31.6501 26.9575 31.1506 27.7624 30.7955C28.5674 30.4356 29.4788 30.2557 30.4968 30.2557C31.529 30.2557 32.4334 30.4356 33.2099 30.7955C33.9911 31.1506 34.6043 31.6454 35.0494 32.2798C35.4944 32.9096 35.7241 33.634 35.7383 34.4531H33.2028ZM40.2322 30.4545L44.0178 41.9034H44.1669L47.9453 30.4545H50.843L45.7152 45H42.4624L37.3416 30.4545H40.2322Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_181_2578",
    x: 14.5,
    y: -24,
    width: 72.5,
    height: 69.8701,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_181_2578"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_181_2578",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_181_2578",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E85555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_181_2578",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9391FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B59EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_181_2578",
    x1: 48.75,
    y1: 0,
    x2: 48.75,
    y2: 19.8701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7371F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#504DE8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvIcon);
export default __webpack_public_path__ + "static/media/csv-icon.b2204f7839c965a3e96a4c93ce87d6cd.svg";
export { ForwardRef as ReactComponent };